import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentCompanyId, getCurrentUserId } from "@/utils";
import { QuantityRecord } from "./form/quantity-table/quantity-table.interface";
import { MaterialRecord } from "./form/material-table/material-table.interface";
import moment from "moment";
/**
 * Tab 枚举
 */
export enum ContractTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  QUANTITY_TAB = "QUANTITY_TAB", // 工程量清单
  MATERIAL_TAB = "MATERIAL_TAB", // 材料清单
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}

/**
 * 计价方式枚举
 */
export enum PriceMannerEnum {
  ZJHT = "zjht", // 总价合同
  DJHT = "djht", // 单价合同
}

export class ProfileReq extends BaseReq {
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目 ID
  signDate: string = moment().format("YYYY-MM-DD"); // 签订日期
  externalContractNo: string = ""; // 外部合同编号
  name: string = ""; // 合同名称
  firstCooperationCompanyId: string = ""; // 甲方ID
  // secondCooperationCompanyId: string = getCurrentCompanyId(); // 乙方ID
  secondCooperationCompanyId: string | undefined = undefined;  // 乙方ID
  contractPricingManner: string = PriceMannerEnum.ZJHT; // 计价方式
  startDate: string = ""; // 开始日期
  endDate: string = ""; // 结束日期
  provinceId: string | number = ""; // 履约地省
  cityId: string | number = ""; // 履约地市
  districtId: string | number = ""; // 履约地区
  address: string = ""; // 详细地址
  maintenancePeriod: number = 0; // 维保期限
  maintenancePeriodUnit: string = "year"; // 维保期限-单位
  amount: number = 0; // 合同签订金额
  assuringMoney: number = 0; // 履约保证金
  qualityAssuranceRatio: number = 0; // 质保金比例
  qualityAssuranceMoney: number = 0; // 质保金金额
  invoiceType: string | undefined = undefined; // 发票类型
  taxRate: string | undefined = undefined; // 税率
  salesmanUserId: string = ""; // 业务员ID
  projectManagerUserId: string = ""; // 项目经理ID
  agentUserId: string = getCurrentUserId(); // 经办人ID
  paymentAgreement: string = ""; // 收款协议
  mainClause: string = ""; // 主要条款
  remark: string = ""; // 备注
  fileList: FileRecord[] = []; //附件
  quantitiesList: QuantityRecord[] = [];
  materialList: MaterialRecord[] = [];
}

export class ProfilePageReq extends PaginationReq {
  contractName: string | undefined = undefined; // 合同名称
  projectId: string = ""; // 项目 ID
  projectName: string | undefined = undefined; // 项目名称
  projectTypeId: string | undefined = undefined; // 项目类型
  cooperationCompanyName: string | undefined = undefined; // 甲方名称
  responsiblePersonUserId: string | undefined = undefined; // 经办人ID
  contractStatus: string | undefined = undefined; // 合同状态
  contractStatusList: string[] = []; //多个合同状态
  receivableAmountStatus: string | undefined = undefined; // 回款状态
  flowStatus: string | undefined = undefined; // 审批状态
  externalContractNo: string | undefined = undefined; // 外部合同编号
}

export class ProfileListRecord extends UpdaterResp {
  id: number = 0; // 合同ID
  bizNo: string = ""; // 合同编号
  name: string = ""; // 合同名称
  projectName: string = ""; // 项目名称
  firstCooperationCompanyName: string = ""; // 甲方名称
  signDate: string = ""; // 签订日期
  amount: string = ""; // 合同金额
  agentTenantUserName: string = ""; // 经办人名称
  managerTenantUserName: string = ""; // 项目经理
  receivableAmountStatusName: string = ""; // 回款状态
  contractStatusName: string = ""; // 合同状态
  flowStatusName: string = ""; // 审批状态
  lastModifiedTime: string = ""; // 更新时间
}

export class ProfilePageResp extends PaginationResp<ProfileListRecord> {}

export class ContractSimpleListReq extends BaseReq {
  contractStatus: string | undefined = undefined; // 合同状态
  projectId: string | undefined = undefined; // 项目ID
  id: string = "";
  name: string = "";
  contractStatusList: string | undefined = undefined; // 合同状态集合
  addRightBizType: string | undefined = undefined;
  firstDisplayProjectId: string | undefined = undefined;
}

export class ContractSimpleRecord {
  bizNo: string = ""; // 合同编号
  id: string = ""; // 合同ID
  name: string = ""; // 合同名称
}

export class ContractSimpleListResp extends PaginationResp<ContractSimpleRecord> {
  id: string;
  name: string;
  contractPricingManner: string | undefined = undefined;
}

export class ProfileDetailResp extends UpdaterResp {
  id: string = ""; // 合同ID
  bizNo: string = ""; // 合同编号
  receivableAmountStatusName: string = ""; // 收款状态
  contractStatusName: string = ""; // 合同状态
  flowStatusName: string = ""; // 审批状态
  projectId: string = ""; // 所属项目ID
  projectName: string = ""; // 所属项目名称
  signDate: string = ""; // 签订日期
  externalContractNo: string = ""; // 外部合同编号
  name: string = ""; // 合同名称
  firstCooperationCompanyName: string = ""; // 甲方名称
  firstCooperationCompanyId: string = "";
  secondCooperationCompanyName: string = ""; // 乙方名称
  contractPricingMannerValue: string = ""; // 计价方式
  contractPricingManner:string = "";
  startDate: string = ""; // 开始日期
  endDate: string = ""; // 结束日期
  fulfillmentAddress: string = ""; // 履约地
  provinceId: string | number = ""; // 履约地省
  cityId: string | number = ""; // 履约地市
  districtId: string | number = ""; // 履约地区
  address: string = ""; // 详细地址
  maintenancePeriod: number = 0; // 维保期限
  maintenancePeriodUnit: string = ""; // 维保期限-单位
  maintenancePeriodUnitValue: string = ""; // 维保期限-单位名称
  amount: number = 0; // 合同金额
  initAmount: number = 0; //合同初始金额
  visaAmount: number = 0; //签证金额
  displayVisaAmount: string = ""; //签证金额千分位展示
  assuringMoney: string = ""; // 履约保证金
  qualityAssuranceRatio: string = ""; // 质保金比例
  qualityAssuranceMoney: string = ""; // 质保金金额
  invoiceType: string = ""; // 发票类型
  invoiceTypeName: string = ""; // 发票类型-显示值
  taxRate: string = ""; // 税率
  taxRateValue: string = ""; // 税率-显示值
  salesmanUserId: string = ""; // 业务员ID
  salesTenantUserName: string = ""; // 业务员名称
  projectManagerUserId: string = ""; // 项目经理ID
  managerTenantUserName: string = ""; // 项目经理名称
  agentUserId: string = ""; // 经办人ID
  agentTenantUserName: string = ""; // 经办人名称
  paymentAgreement: string = ""; // 收款协议
  mainClause: string = ""; // 主要条款
  remark: string = ""; // 备注
  totalVisaAmount: number = 0; // 累计签证金额
  projectTotalPrice: number = 0; // 本次上报完成产值
  currentPrice: number = 0; // 项目累计上报完成产值
}
